import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useOfferSummaries } from '@/hooks/useOfferSummaries'
import { OffersOverview } from './OffersOverview'

/** Landing screen for the logged-in dashboard: pick an offer, then see its geos and cap. */
export function OffersIndexPage() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { offers, isLoading, error, refresh } = useOfferSummaries('/api/dashboard/offers')

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl font-semibold tracking-tight text-text-primary">
          {user?.name ? `Welcome, ${user.name}` : 'Your offers'}
        </h1>
        <p className="mt-0.5 text-sm text-text-muted">
          Pick an offer to see its geos, caps and overflow.
        </p>
      </div>
      <OffersOverview
        offers={offers}
        isLoading={isLoading}
        error={error}
        onRetry={refresh}
        onSelect={(offerId) => navigate(`/offer/${offerId}`)}
      />
    </div>
  )
}
